//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DocumentClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type DeferPatchDocumentQueryParameters = {
  id: number ;
}

export type PatchDocumentQueryParameters = {
  id: number ;
}

export type DeleteDocumentQueryParameters = {
  id: number ;
}

export type GetDocumentQueryParameters = {
  id: number ;
}

export type SearchDocumentQueryParameters = {
  revisionId?: number | undefined ;
  status?: Types.Status | null | undefined ;
  isExported?: boolean | null | undefined ;
  isReadonly?: boolean | null | undefined ;
  hasRoles?: boolean | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type GetExpiredVariablesDocumentQueryParameters = {
  id: number ;
}

export function deferCreateUrl(): string {
  let url_ = getBaseUrl() + "/api/documents/defer";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deferCreateMutationKey(): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'deferCreate',
    ]);
}

export function useDeferCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DocumentDto, unknown, Types.CreateDocumentDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DocumentDto, unknown, Types.CreateDocumentDto, TContext> {
  const key = deferCreateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateDocumentDto) => Client.deferCreate(dto),
    mutationKey: key,
  });
}
  
export function deferCreateFromTemplateUrl(): string {
  let url_ = getBaseUrl() + "/api/documents/defer/from-template";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deferCreateFromTemplateMutationKey(): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'deferCreateFromTemplate',
    ]);
}

export function useDeferCreateFromTemplateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DocumentDto, unknown, Types.CreateDocumentBasedOnTemplateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DocumentDto, unknown, Types.CreateDocumentBasedOnTemplateDto, TContext> {
  const key = deferCreateFromTemplateMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateDocumentBasedOnTemplateDto) => Client.deferCreateFromTemplate(dto),
    mutationKey: key,
  });
}
  
export function deferPatchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/documents/defer/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deferPatchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'deferPatch',
      id as any,
    ]);
}

export function useDeferPatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DocumentDto, unknown, Types.PatchDocumentDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DocumentDto, unknown, Types.PatchDocumentDto, TContext> {
  const key = deferPatchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchDocumentDto) => Client.deferPatch(id, dto),
    mutationKey: key,
  });
}
  
type DeferPatch__MutationParameters = DeferPatchDocumentQueryParameters & {
  dto: Types.PatchDocumentDto;
}

export function useDeferPatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DocumentDto, unknown, DeferPatch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeferPatchDocumentQueryParameters}): UseMutationResult<Types.DocumentDto, unknown, DeferPatch__MutationParameters, TContext> {
  const key = deferPatchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeferPatch__MutationParameters) => Client.deferPatch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/documents/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'patch',
      id as any,
    ]);
}

export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DocumentDto, unknown, Types.PatchDocumentDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DocumentDto, unknown, Types.PatchDocumentDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchDocumentDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchDocumentQueryParameters & {
  dto: Types.PatchDocumentDto;
}

export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DocumentDto, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchDocumentQueryParameters}): UseMutationResult<Types.DocumentDto, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function deleteUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/documents/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'delete',
      id as any,
    ]);
}

export function useDeleteMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.delete_(id),
    mutationKey: key,
  });
}
  
type Delete__MutationParameters = DeleteDocumentQueryParameters

export function useDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Delete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteDocumentQueryParameters}): UseMutationResult<void, unknown, Delete__MutationParameters, TContext> {
  const key = deleteMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Delete__MutationParameters) => Client.delete_(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/documents/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.DocumentDto, unknown, Types.DocumentDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DocumentDto, unknown, Types.DocumentDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(id: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetDocumentQueryParameters;

    return trimArrayEnd([
        'DocumentClient',
        'get',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.DocumentDto, TError = unknown>(dto: GetDocumentQueryParameters, options?: Omit<UseQueryOptions<Types.DocumentDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.DocumentDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.DocumentDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.DocumentDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DocumentDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetDocumentQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DocumentDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(id),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.DocumentDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.DocumentDto | undefined) => Types.DocumentDto, id: number) {
  queryClient.setQueryData(getQueryKey(id),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DocumentDto | undefined) => Types.DocumentDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function deferBulkPatchUrl(): string {
  let url_ = getBaseUrl() + "/api/documents/defer/bulk-patch";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deferBulkPatchMutationKey(): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'deferBulkPatch',
    ]);
}

export function useDeferBulkPatchMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.PatchDocumentEntry[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchDocumentEntry[], TContext> {
  const key = deferBulkPatchMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (entries: Types.PatchDocumentEntry[]) => Client.deferBulkPatch(entries),
    mutationKey: key,
  });
}
  
export function bulkDeleteUrl(): string {
  let url_ = getBaseUrl() + "/api/documents/bulk-delete";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function bulkDeleteMutationKey(): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'bulkDelete',
    ]);
}

export function useBulkDeleteMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, number[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, number[], TContext> {
  const key = bulkDeleteMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (ids: number[]) => Client.bulkDelete(ids),
    mutationKey: key,
  });
}
  
export function searchUrl(revisionId?: number | undefined, status?: Types.Status | null | undefined, isExported?: boolean | null | undefined, isReadonly?: boolean | null | undefined, hasRoles?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/documents?";
if (revisionId === null)
    throw new Error("The parameter 'revisionId' cannot be null.");
else if (revisionId !== undefined)
    url_ += "RevisionId=" + encodeURIComponent("" + revisionId) + "&";
if (status !== undefined && status !== null)
    url_ += "Status=" + encodeURIComponent("" + status) + "&";
if (isExported !== undefined && isExported !== null)
    url_ += "IsExported=" + encodeURIComponent("" + isExported) + "&";
if (isReadonly !== undefined && isReadonly !== null)
    url_ += "IsReadonly=" + encodeURIComponent("" + isReadonly) + "&";
if (hasRoles !== undefined && hasRoles !== null)
    url_ += "HasRoles=" + encodeURIComponent("" + hasRoles) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfDocumentListItemDto, unknown, Types.PagedResultOfDocumentListItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfDocumentListItemDto, unknown, Types.PagedResultOfDocumentListItemDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchDocumentQueryParameters): QueryKey;
export function searchQueryKey(revisionId?: number | undefined, status?: Types.Status | null | undefined, isExported?: boolean | null | undefined, isReadonly?: boolean | null | undefined, hasRoles?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { revisionId, status, isExported, isReadonly, hasRoles, offset, limit, sortBy, sortOrder,  } = params[0] as SearchDocumentQueryParameters;

    return trimArrayEnd([
        'DocumentClient',
        'search',
        revisionId as any,
        status as any,
        isExported as any,
        isReadonly as any,
        hasRoles as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'DocumentClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as number | undefined,       context.queryKey[3] as Types.Status | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as boolean | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as string | null | undefined,       context.queryKey[10] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfDocumentListItemDto, TError = unknown>(dto: SearchDocumentQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfDocumentListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useSearchQuery<TSelectData = Types.PagedResultOfDocumentListItemDto, TError = unknown>(revisionId?: number | undefined, status?: Types.Status | null | undefined, isExported?: boolean | null | undefined, isReadonly?: boolean | null | undefined, hasRoles?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfDocumentListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfDocumentListItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfDocumentListItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let revisionId: any = undefined;
  let status: any = undefined;
  let isExported: any = undefined;
  let isReadonly: any = undefined;
  let hasRoles: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ revisionId, status, isExported, isReadonly, hasRoles, offset, limit, sortBy, sortOrder,  } = params[0] as SearchDocumentQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [revisionId, status, isExported, isReadonly, hasRoles, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfDocumentListItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(revisionId, status, isExported, isReadonly, hasRoles, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfDocumentListItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfDocumentListItemDto | undefined) => Types.PagedResultOfDocumentListItemDto, revisionId?: number | undefined, status?: Types.Status | null | undefined, isExported?: boolean | null | undefined, isReadonly?: boolean | null | undefined, hasRoles?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(revisionId, status, isExported, isReadonly, hasRoles, offset, limit, sortBy, sortOrder),
    updater
  );
}

export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfDocumentListItemDto | undefined) => Types.PagedResultOfDocumentListItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getExpiredVariablesUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/documents/{id}/expired-variables";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function getExpiredVariablesMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DocumentClient',
      'getExpiredVariables',
      id as any,
    ]);
}

export function useGetExpiredVariablesMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.ExpiredVariableDto[], unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ExpiredVariableDto[], unknown, void, TContext> {
  const key = getExpiredVariablesMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.getExpiredVariables(id),
    mutationKey: key,
  });
}
  
type GetExpiredVariables__MutationParameters = GetExpiredVariablesDocumentQueryParameters

export function useGetExpiredVariablesMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.ExpiredVariableDto[], unknown, GetExpiredVariables__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: GetExpiredVariablesDocumentQueryParameters}): UseMutationResult<Types.ExpiredVariableDto[], unknown, GetExpiredVariables__MutationParameters, TContext> {
  const key = getExpiredVariablesMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: GetExpiredVariables__MutationParameters) => Client.getExpiredVariables(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}